<template>
	<div class="leader-container">
		<v-simple-table fixed-header height="95%" dense class="content">
			<template v-slot:default>
				<thead>
					<tr>
						<th class="text-left">
							NAME
						</th>
						<th class="text-right">
							POINTS
						</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="score in score_list"
						:key="score.name"
					>
						<td>{{ score.name }}</td>
						<td class="text-right">{{ score.points }}</td>
					</tr>
				</tbody>
			</template>
		</v-simple-table>
		<div class="caption time">{{ as_at }}</div>
	</div>
</template>

<script>

// We auto reload this data every minute!
import moment from 'moment';

export default {
	name: 'Leaderboard',
	data() {
		return {
			score_list: [],
			timer: null,
			as_at: '',
		};
	},
	beforeMount() {
		// update it for the first time
		this.update_leaderboard();
	},
	beforeDestroy() {
		if (this.timer) {
			// console.log("Clear timer");
			clearTimeout(this.timer);
		}
	},
	methods: {
		update_leaderboard() {
			// console.log("reload");

			let url = '/api/dashboard/leaderboard';

			axios
				.get(url, {
					headers: {
						Authorization: 'Bearer ' + this.$store.state.token,
						Accept: 'application/json',
					},
				})
				.then((d) => {
					let json = d.data;
					if (json.status == 'OK') {
						this.score_list = json.data;
						this.as_at =
							'as at ' + moment(new Date()).format('DD MMM YYYY h:mma');

						// attempt to update every minute
						this.timer = setTimeout(this.update_leaderboard, 60000);
					} else {
						console.log(json.reason);
					}
				})
				.catch((e) => {
					console.log(e.message);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.leader-container {
  padding: 8px 16px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
	border-radius: 0 0 4px 4px;
}
.content {
  height: 90%;
  background: #eeeeee;
}
.time {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;
	text-align: right;
	letter-spacing: 0.4px;
	color: rgba(25, 42, 62, 0.36);
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: rgba(25, 42, 62, 0.7);
	height: 40px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
	height: 40px;
}
</style>
